import { Modal, Container, Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import http from "../../../common/http-common";
import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";
import { toast } from "react-toastify";
import SendEmail from "../NewTicket/SendEmail"
import { useNavigate } from "react-router-dom";

const AddNewTicket = (props) => {

    const [showSendEmailConfirmation, setShowSendEmailConfirmation] = useState(false);
    const [ticketMstId, setTicketMstId] = useState("");
    const [ticketNum, setTicketNum] = useState("");
    const navigate = useNavigate();

    const onCancelSendEmailHandler = () => {
        setShowSendEmailConfirmation(false)
        props.onClear();
    };

    //Function
    const onHideSaveConfirmationHandler = () => {
        props.onHide();
    };

    const onSaveConfirmHandler = () => {
        let functionName = "onSaveConfirmHandler";

        try {
            props.onLoading(true, "Saving Ticket, please wait...");

            if (props.selectedFiles.length === 0) {

                const acknowledged_by = 
                props.agent.value == undefined ? null : props.agent.value;

                const data = {
                    ORG_ID: props.companyDetail.value,
                    ORG_NAME: props.companyDetail.label,
                    SYSTEM_MST_ID: props.systemDetail.value,
                    SYSTEM_MST_NAME: props.systemDetail.label,
                    CREATE_BY: props.ticketOwner.value,
                    CREATE_NAME: props.ticketOwner.label,
                    ACKNOWLEDGED_BY: acknowledged_by,
                    ACKNOWLEDGED_NAME: props.agent.label,
                    TICKET_CATEGORY_ID: props.categoryDetail.value,
                    TICKET_CATEGORY_NAME: props.categoryDetail.label,
                    TICKET_PRIORITY_TYPE_ID: props.priorityDetail.value,
                    SUBJECT: props.addData.SUBJECT.trim(),
                    TICKET_DETAILS: props.addData.TICKET_DETAILS.trim(),
                    TICKET_STATUS_TYPE_ID: props.TICKET_STATUS_TYPE_ID,
                    TICKET_STATUS_TYPE_NAME: props.TICKET_STATUS_TYPE_NAME,
                    // TICKET_DETAILS: JSON.stringify(props.addData.TICKET_DETAILS.trim()),
                    STANDBY_FLAG: props.addData.STANDBY_FLAG === undefined || props.addData.STANDBY_FLAG === false ? "N" : "Y",
                    TO_DATETIME: props.addData.TO_DATETIME === undefined ? "" : common.c_Dis_DateTime(props.addData.TO_DATETIME).val,
                    FROM_DATETIME: props.addData.FROM_DATETIME === undefined ? "" : common.c_Dis_DateTime(props.addData.FROM_DATETIME).val,
                    UPDATE_BY: props.userId,
                    FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
                };
                console.log("check data send", data);
                http
                    .post("api/NewTicket/AddNewTicketWithoutFolder", data, { timeout: common.DEFAULT_TIMEOUT })
                    .then((response) => {
                        toast.success("Ticket Successfully Uploaded.");
                        // setShowSendEmailConfirmation(true);
                        setTicketMstId(response.data.TICKET_MST_ID);
                        setTicketNum(response.data.TICKET_NUM);
                        // toSendEmail();
                        props.onClear();
                        navigate("/Home"); //navigate to home
                    })
                    .catch((err) => {
                        toast.error("Failed to save. Please try again.");
                        common.c_LogWebError(props.page, functionName, err);
                    })
                    .finally(() => {
                        props.onLoading(false, "Loading...");
                        onHideSaveConfirmationHandler();
                        // toSendEmail();
                    })
            }
            else {
                const fileArr = [...props.selectedFiles];
                const formData = new FormData();
                fileArr.forEach((file) => {
                    formData.append("file", file);
                });

                return http
                    .post(common.c_getApiUrl() + "api/NewTicket/AddNewTicketWithFolder", formData, {
                        headers: {
                            
                            "Content-Type": "multipart/form-data",
                            ORG_ID: props.companyDetail.value,
                            ORG_NAME: props.companyDetail.label,
                            SYSTEM_MST_ID: props.systemDetail.value,
                            SYSTEM_MST_NAME: props.systemDetail.label,
                            CREATE_BY: props.ticketOwner.value,
                            CREATE_NAME: props.ticketOwner.label,
                            ACKNOWLEDGED_BY: props.agent.value ? props.agent.value : "",
                            ACKNOWLEDGED_NAME: props.agent.label,
                            TICKET_CATEGORY_ID: props.categoryDetail.value,
                            TICKET_CATEGORY_NAME: props.categoryDetail.label,
                            TICKET_PRIORITY_TYPE_ID: props.priorityDetail.value,
                            SUBJECT: props.addData.SUBJECT.trim(),
                            TICKET_DETAILS: props.addData.TICKET_DETAILS === null ? "" : JSON.stringify(props.addData.TICKET_DETAILS.trim()),
                            TICKET_STATUS_TYPE_ID: props.TICKET_STATUS_TYPE_ID,
                            TICKET_STATUS_TYPE_NAME: props.TICKET_STATUS_TYPE_NAME,
                            // TICKET_DETAILS: props.addData.TICKET_DETAILS.trim(),
                            STANDBY_FLAG: props.addData.STANDBY_FLAG === undefined || props.addData.STANDBY_FLAG === false ? "N" : "Y",
                            TO_DATETIME: props.addData.TO_DATETIME === undefined ? "" : common.c_Dis_DateTime(props.addData.TO_DATETIME).val,
                            FROM_DATETIME: props.addData.FROM_DATETIME === undefined ? "" : common.c_Dis_DateTime(props.addData.FROM_DATETIME).val,
                            UPDATE_BY: props.userId,
                            FROM_SOURCE: JSON.stringify({
                                SOURCE: "WEB",
                                MODULE_ID: props.module,
                            }),
                        },
                    })
                    .then((response) => {
                        toast.success("Ticket Successfully Uploaded.");
                        // setShowSendEmailConfirmation(true);
                        setTicketMstId(response.data.TICKET_MST_ID);
                        setTicketNum(response.data.TICKET_NUM);
                        // toSendEmail();
                        props.onClear();
                        navigate("/Home"); //navigate to home
                    })
                    .catch((err) => {
                        toast.error("Failed to save. Please try again.");
                        common.c_LogWebError(props.page, functionName, err);
                    })
                    .finally(() => {
                        props.onLoading(false, "Loading...");
                        onHideSaveConfirmationHandler();
                        // toSendEmail();
                    })
            }
        } catch (err) {
            props.onLoading(false, "Loading...");
            toast.error("Failed to save. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
        }
    };

    const toSendEmail = () => {
        let functionName = "onSaveConfirmHandler";

        try {
            props.onLoading(true, "Sending email, please wait...");
            const data = {
                ORG_NAME: props.companyDetail.label,
                SYSTEM_MST_NAME: props.systemDetail.label,
                SYSTEM_MST_ID: props.systemDetail.value,
                TICKET_MST_ID: ticketMstId,
                TICKET_NUM: ticketNum,
                UPDATE_BY: props.userId,
                FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
            };
            http
                .post("api/NewTicket/SendEmail", data, { timeout: common.DEFAULT_TIMEOUT })
                .then((response) => {
                    // toast.success("Email Successfully Send.");
                    // toast.success("Email Successfully Upload and Send.");
                    props.onClear();
                })
                .catch((err) => {
                    // toast.error("Failed to send");
                    common.c_LogWebError(props.page, functionName, err);
                })
                .finally(() => {
                    props.onLoading(false, "Loading...");
                    props.onHide();
                })


        } catch (err) {
            props.onLoading(false, "Loading...");
            toast.error("Failed to send");
            common.c_LogWebError(props.page, functionName, err);
        }
    };

    const messageSave = (
        <>
            <span style={{ fontWeight: 'bold', fontSize: "20px" }}>
                Confirm to save ticket for
            </span>

            <br />Company : <span style={{ color: 'red', fontWeight: 'bold' }}>{props.companyDetail.label}</span>
            <br />System : <span style={{ color: 'red', fontWeight: 'bold' }}>{props.systemDetail.label}</span>
            {props.ticketOwner?.label && props.ticketOwner.label.trim() !== "" && props.ticketOwner.label.trim() !== null && (
            <>
                <br />TICKET OWNER : <span style={{ color: 'red', fontWeight: 'bold' }}>{props.ticketOwner.label}</span>
            </>
            )}
            {props.agent?.label && props.agent.label.trim() !== "" && props.agent.label.trim() !== null && (
            <>
                <br />AGENT : <span style={{ color: 'red', fontWeight: 'bold' }}>{props.agent.label}</span>
            </>
            )}
        </>
    );

    return (
        <>
            <Comp.ConfirmModal
                show={props.show}
                onHide={onHideSaveConfirmationHandler}
                onConfirm={onSaveConfirmHandler}
            >
                {messageSave}
            </Comp.ConfirmModal>

            {/* <SendEmail
                page={props.page}
                module={props.module}
                userId={props.userId}
                show={showSendEmailConfirmation}
                onHide={onCancelSendEmailHandler}
                ticketMstId={ticketMstId}
                ticketNum={ticketNum}
                orgName={props.companyDetail.label}
                systemName={props.systemDetail.label}
                onReload={props.onReload}
                onLoading={props.onLoading}
                onClear={props.onClear}
            /> */}
        </>
    );
};

export default AddNewTicket;
